import { render, staticRenderFns } from "./prohibition.vue?vue&type=template&id=30a98c09&scoped=true"
import script from "./prohibition.vue?vue&type=script&lang=js"
export * from "./prohibition.vue?vue&type=script&lang=js"
import style0 from "./prohibition.vue?vue&type=style&index=0&id=30a98c09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a98c09",
  null
  
)

export default component.exports